export const groupTypes = Object.freeze({
  CD: 1,
  CI: 2,
  NC: 3,
});

export const formTitles = Object.freeze({
  PDP: "Formulario tipo Promesa de Pago (PDP)",
  reminder: "Formulario tipo Recordatorio",
  reminderPDP: "Formulario tipo Promesa de Pago (PDP) y Recordatorio",
  pays: "Formulario tipo Pago",
});

export const AssignmentType = Object.freeze({
  ContactDirect: 1,
  Result: 2,
  None: 3,
});

export const AssignmentTypeText = {
  [AssignmentType.ContactDirect]: "Cuando se obtenga una respuesta con Contacto Directo",
  [AssignmentType.None]: "Sin asignación automática",
};
